import { toast } from "sonner";

export async function shareOrCopy(data: { title: string; text?: string; url: string }) {
  if (typeof navigator !== "undefined" && typeof navigator.share === "function") {
    try {
      await navigator.share(data);
      return;
    } catch (err) {
      // User aborted — do nothing
      if ((err as DOMException)?.name === "AbortError") return;
    }
  }
  try {
    await navigator.clipboard.writeText(data.url);
    toast.success("Link copied");
  } catch {
    toast.error("Could not copy link");
  }
}
